export default __webpack_public_path__ + "static/media/icon-GNS_full.cdfc4573.svg";